import { Layout } from 'antd';
import BreadcrumbComponent from '../../components/common/breadcrumb';
import TerminalManagementForm from '../../components/views/devices/index';

function TerminalManagementPage() {
  const breadcrumbItems = ["Home", "Device Management"];

  return (
    <Layout className="content-page">
      <BreadcrumbComponent items={breadcrumbItems} />
      <TerminalManagementForm />
    </Layout>
  );
}
export default TerminalManagementPage;
